module.exports = __webpack_public_path__ + "static/media/intra.6ac81680.svg";